import { useMemo, useState } from "react";
import { AdminDetails } from "./AdminDetails";
import { CustomerDetails } from "./CustomerDetails";
import { addCustomer } from "../../Redux/Slice/Customers/AddCustomerSlice";
import { SuccessModel } from "../../Model/SuccessModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PlanDetails } from "./PlanDetails";
import { Loader } from "../../Common/Loader";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";

export const AddCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(1);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({
    autoTopUpDate: "",
    companyName: "",
    credits: 0,
    email: "",
    expiryDate: "",
    joiningDate: "",
    planId: "",
    planType: "",
  });
  const [customerFormData,setCustomerFormData] = useState({
    companyName: "",
    email: "",
    address: {
      address: "",
      state: "",
      city: "",
      country: "",
      zipCode: "",
    },
    countryCallingCode: "+61",
    phoneNumber: "",
    isDefaultEmail: false,
  });
  const [adminDetails, setAdminDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCallingCode: "+61",
    phoneNumber: "",
    role: "",
  });
  const [adminFormError, setAdminFormError] = useState({
    emailError: "",
    phoneError: "",
    firstNameError: "",
    lastNameError: "",
  });
  const [planDetails, setPlanDetails] = useState({
    subscriptionType: "",
    planId: "",
  });

  const handleSubmit = async (planDetails) => {
    // let custdata = {
    //   ...customerDetails,
    //   phoneNumber: customerDetails?.phoneNumber ? customerDetails?.phoneNumber.replace(/\D/g, "") : "",
    // };
    // let admindata = {
    //   ...,
    //   phoneNumber: adminDetails?.phoneNumber? adminDetails?.phoneNumber.replace(/\D/g, "") :"",
    // };
    setIsLoading(true);
    let body = {};
    if (customerFormData.companyName === "") {
      body = {
        admin: {
          ...adminDetails,
          phoneNumber: adminDetails?.phoneNumber
            ? adminDetails?.phoneNumber.replace(/\D/g, "")
            : "",
          planId: planDetails.planId,
        },
      };
    } else if (adminDetails.firstName === "") {
      body = {
        ...customerFormData,
        companyName: customerFormData.companyName.trim(),
        phoneNumber: customerFormData?.phoneNumber
          ? customerFormData?.phoneNumber.replace(/\D/g, "")
          : "",
        planId: planDetails.planId,
      };
    } else {
      body = {
        ...customerFormData,
        companyName: customerFormData.companyName.trim(),
        phoneNumber: customerFormData?.phoneNumber
          ? customerFormData?.phoneNumber.replace(/\D/g, "")
          : "",
        planId: planDetails.planId,
        admin: {
          ...adminDetails,
          phoneNumber: adminDetails?.phoneNumber
            ? adminDetails?.phoneNumber.replace(/\D/g, "")
            : "",
        },
      };
    }
    body.isDefaultEmail = customerFormData.isDefaultEmail;
    const result = await dispatch(addCustomer(body));
    if (
      addCustomer.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Customer created Successfully!");
      setSuccessModel(true);
      dispatch(setUnsavedChanges(false));
      setTimeout(() => {
        setSuccessModel(false);
        navigate("/customers");
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const isDisabledSubmitBtn =  useMemo(() => {
    return (
      customerFormData.companyName.trim() === "" ||
      adminDetails.firstName.trim() === "" ||
      adminDetails.lastName.trim() === "" ||
      adminDetails.email === "" ||
      adminFormError.emailError != "" ||
      adminFormError.phoneError != "" ||
      adminDetails.phoneNumber === ""
    );
  },[adminDetails,adminFormError,customerFormData]);

  return (
    <div className="page__body">
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      <div className="tabsWrap">
        <ul className="tabs">
          <li
            className={
              selectedTab === 1
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(1);
            }}
          >
            Company Details
          </li>
          <li
            className={
              selectedTab === 2
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(2);
            }}
          >
            Admin Details
          </li>
          <li
            className={
              selectedTab === 3
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(3);
            }}
          >
            Plans
          </li>
        </ul>
      </div>
      <div className="tabsContent">
        <CustomerDetails
          selectedTab={selectedTab}
          isEdit={false}
          setSelectedTab={setSelectedTab}
          customerFormData={customerFormData}
          customerDetails={customerDetails}
          setCustomerFormData={setCustomerFormData}
        />
        <AdminDetails
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          isEdit={false}
          adminDetails={adminDetails}
          setAdminDetails={setAdminDetails}
          adminFormError={adminFormError}
          setAdminFormError={setAdminFormError}
          handleSubmit={handleSubmit}
        />
        <PlanDetails
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          isEdit={false}
          isDisabledBtn={isDisabledSubmitBtn}
          setPlanDetails={setPlanDetails}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};
